import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import account from '../views/account.vue'
import viewerTool from '../views/viewerTool.vue'
import viewerArTool from '../views/viewerArTool.vue'
import shareFile from '../views/sharefileView.vue'
import Augmentable from '../views/Augmentable.vue'

import sharepage from '../views/sharepage.vue'
import sharepageEdit from '../views/sharepageEdit.vue'
import sharepages from '../views/sharepages.vue'

import detailedUIofCard from "../views/detailChangeSpotView.vue";

import tabs from "../components/tabs.vue"



import store from '../store'


import DashboardLayout from "../pages/Layout/DashboardLayout.vue";
import EditorLayout from "../pages/Layout/EditorLayout.vue";

//import Dashboard from "../pages/Dashboard.vue";
import Editor from '../pages/Editor.vue';
import UserProfile from "../pages/UserProfile.vue";
import userProfileInfo from "../pages/userProfileInfo.vue";
import GlbFiles from "../pages/GlbFiles.vue";
//import Assets from "../pages/assets.vue";
import glbAssets from "../pages/glbassets.vue";
import hdrAssets from "../pages/hdrassets.vue";
import AddFile from "../pages/addFile.vue";
import AddVersion from "../pages/addVersion.vue";
import BatchImport from "../pages/batchImport.vue";
//import Maps from "../pages/Maps.vue";
import Notifications from "../pages/Notifications.vue";
import Dashboard from "../views/dashboard/augmentableDashboard";
//import { params } from 'vee-validate/dist/types/rules/alpha'

import babylontest from "../pages/babylonTest.vue"


import passwordReset from "../components/passwordReset.vue"

import augmentableViewer from "../views/augmentableViewer";



Vue.use(VueRouter)

const routes = [{
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
  },

  {
    path: '/',
    name: 'account',
    component: account
  },
  {
    path: '/tabs',
    name: 'tabs',
    component: tabs
  },
  {
    path: '/viewer',
    name: 'viewer',
    component: Augmentable,
    beforeEnter: (to, from, next) => {
      if (store.state.authenticated == false) {
        next(false);
      } else {
        console.log(store.state.authenticated);
        
        
        // if(from.path === "/" || from.path === "/dashboard" || from.path ==="/assets" || from.path ==="/editor"){
        //   const vuex = JSON.parse(localStorage.getItem('vuex'));
        // if(vuex.fileDetail){
        //   localStorage.setItem(vuex.fileDetail, "");
        // }
        // }
        next();
      }
    },

    children: [
      {
          path: "/changespot/:slug",
          name: 'changeSpotV',
          component: detailedUIofCard,
          props: true,
        },
    ]

    
  },
  
  {
    path: '/Augmentable',
    name: 'Augmentable',
    component: viewerTool,
    beforeEnter: (to, from, next) => {

      if (store.state.authenticated == false) {
        next(false);
      } else {
        console.log(store.state.authenticated)
        next();
      }
    }
  },
  {
        path: '/sharepage/edit/:slug',
        name: 'sharepageEdit',
        component: sharepageEdit,
        beforeEnter: (to, from, next) => {

              if (store.state.authenticated == false) {
                next(false);
              } else {
                console.log(store.state.authenticated)
                next();
              }
            }
      },
  {
    path: '/viewerAR',
    name: 'viewerAR',
    component: viewerArTool,

    beforeEnter: (to, from, next) => {

      if (store.state.authenticated == false) {
        next(false);
      } else {
        console.log(store.state.authenticated)
        next();
      }
    }
  },

  {
    path: '/augmentableViewer',
    name: 'augmentableViewer',
    component: augmentableViewer,

    beforeEnter: (to, from, next) => {

      if (store.state.authenticated == false) {
        next(false);
      } else {
        console.log(store.state.authenticated)
        next();
      }
    }
  },

  {
    path: '/sharepage/:slug',
    name: 'sharepage',
    component: sharepage,
    
    
    // beforeEnter: (to, from, next) => {
    // console.log(to.path);
    // console.log(from.path);
    // console.log(next);
    // var slug = to.path.split("/");
    
    // let lang = slug[slug.length - 1];
    // if(lang !== "en"){
    //   next({ path: '/sharepage/en'})
    //   console.log(lang);
    // }
    // if (pathPre[1] === "changespot") {
    //   var child = this.$refs.viewerRef;
    //   child.updatedTasksData();
    //   //this.updatedTasksData();
    // }
    
  },
  
  {
    path: '/sharefile/:slug',
    name: 'shareFile',
    component: shareFile,
    /*
    //props: true
    //props: { slug: params.slug }
    */

   

    

    // beforeRouteEnter(to, from, next) {
    //   console.log(to);
    //   console.log(from);
    //   console.log(next);
    
    // }
    

        /*
    beforeEnter: (to, from, next) => {
      //console.log(to.params.slug);
      

      if (store.state.authenticated == false) {
        next(false);
      } else {
        var dg = to.params.slug;
        console.log(typeof(dg));
        //console.log(to.params.slug);
        this.$store.commit("setShareFileSlug", dg);
        console.log(store.state.sharefileSlug);
        console.log(store.state.authenticated);
        next();
      }
    }
    */
  },

  // {
  //         path: "/changespot/:slug",
  //         name: 'changeSpot',
  //         component: detailedUIofCard,
  //         props: true,
        // },

      {
        path: '/password/reset/confirm/:uid/:token',
        name: 'password-reset',
        component: passwordReset,
      },

        {
        path: "/babylonTest",
        name: "Babylon",
        component: babylontest,

        beforeEnter: (to, from, next) => {

          if (store.state.authenticated == false) {
            next(false);
          } else {
            console.log(store.state.authenticated)
            next();
          }
        }
      },

  {
    path: "/dashboard",
    name: 'dashboad',
    component: DashboardLayout,
    beforeEnter: (to, from, next) => {

      if (store.state.authenticated == false) {
        next(false);
      } else {
        console.log(store.state.authenticated)
        next();
      }
    },


    children: [{
        path: "/dashboard",
        name: "Dashboard",
        meta: {
          title: 'Augmentable-Dashboard'
        },
        component: Dashboard,


        beforeEnter: (to, from, next) => {
          if (store.state.authenticated == false) {
            next(false);
          } else {
            if(store.state.userType === "basic"){
              next({ path: '/assets'});
            }
            console.log(store.state.authenticated)
            next();
          }
        },
        

        children: [
          {
          path: "/changespot/:slug",
          name: 'changeSpotD',
          component: detailedUIofCard,
          props: true,
        },
        ]

      },
      
      {
        path: "/user",
        name: "User PProfile",
        component: UserProfile,


        beforeEnter: (to, from, next) => {

          if (store.state.authenticated == false) {
            next(false);
          } else {
            console.log(store.state.authenticated)
            next();
          }
        }
      },
      {
        path: "/user_profile",
        name: "User Profile",
        component: userProfileInfo,
        props: true,


        beforeEnter: (to, from, next) => {

          if (store.state.authenticated == false) {
            next(false);
          } else {
            if(store.state.userType === "basic"){
              next({ path: '/assets'});
            }
            console.log(store.state.authenticated)
            next();
          }
        }
      },
      {
        path: "/assets/:slug",
        name: "File Detail",
        component: GlbFiles,
        props: true,
        // props: (route) => ({
        //   ...route.params
        // }),


        beforeEnter: (to, from, next) => {

          if (store.state.authenticated == false) {
            next(false);
          } else {
            console.log(store.state.authenticated)
            next();
          }
        }
      },
      
      
      
      {
        path: "/assets",
        name: "Assets",
        component: glbAssets,


        beforeEnter: (to, from, next) => {

          if (store.state.authenticated == false) {
            next(false);
          } else {
            console.log(store.state.authenticated)
            next();
          }
        }
      },
      {
        path: "/glbassets",
        name: "glbAssets",
        component: glbAssets,


        beforeEnter: (to, from, next) => {

          if (store.state.authenticated == false) {
            next(false);
          } else {
            console.log(store.state.authenticated)
            next();
          }
        }
      },
      {
        path: "/hdrassets",
        name: "hdrAssets",
        component: hdrAssets,


        beforeEnter: (to, from, next) => {

          if (store.state.authenticated == false) {
            next(false);
          } else {
            console.log(store.state.authenticated)
            next();
          }
        }
      },
      {
        path: "/batchImport",
        name: "Batch Import",
        component: BatchImport,


        beforeEnter: (to, from, next) => {

          if (store.state.authenticated == false) {
            next(false);
          } else {
            console.log(store.state.authenticated)
            next();
          }
        }
      },
      {
        path: "/addFile",
        name: "Add Asset",
        component: AddFile,
        props: true,


        beforeEnter: (to, from, next) => {

          if (store.state.authenticated == false) {
            next(false);
          } else {
            console.log(store.state.authenticated)
            next();
          }
        }
      },
      {
        path: "/addVersion",
        name: "Add Version",
        component: AddVersion,


        beforeEnter: (to, from, next) => {

          if (store.state.authenticated == false) {
            next(false);
          } else {
            console.log(store.state.authenticated)
            next();
          }
        }
      },

      {
        path: '/sharepages',
        name: 'sharepages',
        component: sharepages,
        beforeEnter: (to, from, next) => {

              if (store.state.authenticated == false) {
                next(false);
              } else {
                console.log(store.state.authenticated)
                next();
              }
            }
      },
      
      
      {
        path: "/notifications",
        name: "Notifications",
        component: Notifications,

        beforeEnter: (to, from, next) => {

          if (store.state.authenticated == false) {
            next(false);
          } else {
            console.log(store.state.authenticated)
            next();
          }
        }
      },

      
      
    ]
  },

  {
    path: "/editor",
    name: 'editor',
    component: EditorLayout,
    beforeEnter: (to, from, next) => {

      if (store.state.authenticated == false) {
        next(false);
      } else {
        console.log(store.state.authenticated)
        next();
      }
    },


    children: [
      {
        path: '/editor',
        name: 'Editor',
        meta: {
              title: 'Augmentable-Editor'
            },
        component: Editor,
        beforeEnter: (to, from, next) => {

          if (store.state.authenticated == false) {
            next(false);
          } else {
            console.log(store.state.authenticated)
            next();
          }
        },
      },
     
    ]
  },

  /*

  {
    path: '/dashboard1',
    component: () => import('@/views/dashboard/Index'),
    children: [
      // Dashboard
      {
        name: 'Dashboard',
        path: '/dashboard1',
        component: () => import('@/views/dashboard/Dashboard'),
      },
      // Pages
      {
        name: 'User Profile',
        path: '/pages/user',
        component: () => import('@/views/dashboard/pages/UserProfile'),
      },
      {
        name: 'Notifications',
        path: '/components/notifications',
        component: () => import('@/views/dashboard/component/Notifications'),
      },
      {
        name: 'Icons',
        path: '/components/icons',
        component: () => import('@/views/dashboard/component/Icons'),
      },
      {
        name: 'Typography',
        path: '/components/typography',
        component: () => import('@/views/dashboard/component/Typography'),
      },
      // Tables
      {
        name: 'Regular Tables',
        path: '/tables/regular-tables',
        component: () => import('@/views/dashboard/tables/RegularTables'),
      },
      // Maps
      {
        name: 'Google Maps',
        path: '/maps/google-maps',
        component: () => import('@/views/dashboard/maps/GoogleMaps'),
      },
      // Upgrade
      {
        name: 'Upgrade',
        path: '/upgrade',
        component: () => import('@/views/dashboard/Upgrade'),
      },
    ],
  },
  */

]

document.title = "augmentable";

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router